import { render, staticRenderFns } from "./section-like-list.vue?vue&type=template&id=27082ad2&"
import script from "./section-like-list.vue?vue&type=script&lang=js&"
export * from "./section-like-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports